import React, {
  ReactElement,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import Box from "@mui/material/Box";

export const MultipleRowsCell = ({ props,apiRef }: { props: any,apiRef:any }): ReactElement => {

  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (
      divWidth['element'] > divWidth['cell'] ||
      (props.value?.status_lamp && props.value?.icon)
    ) {
      setTooltip(true);
    }
  });
  const tags = props?.value || [];

  const colors = tags.map((item:any)=>{
    const bgColor = item?.color?.color ? item?.color?.color : '';
    return bgColor;
  });

  let background = "";

  if (colors.length === 1) {
    background = colors[0];
  } else if (colors.length > 1) {

    const step = 100 / colors.length;

    const gradient = colors
      .map((color:any, index:any) => `${color?color:'transparent'} ${index * step}% ${index * step + step}%`)
      .join(", ");
    background = `linear-gradient(180deg, ${gradient})`;
  }

  useLayoutEffect(() => {
    if (divRef.current) {
      const divElement:any = divRef.current;
      const parentElement = divElement.parentNode;

      if (parentElement) {
        parentElement.style.background = background;
      }

    }
  }, [props.value]);

  return (

    <Box
      ref={divRef}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={tags.map(function (item: any, index: number) {
              const name = item?.name ? item?.name : '-';
              return <div key={index}>{name}</div>;
            })}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <div>
              {tags.map((item:any)=>{

                return <div
                  style={{
                    color: (item?.color?.color && item?.color?.id === 21 ) ? '#fff' : 'inherit'
                  }}
                >{item?.name}</div>
              })}
            </div>
          </Tooltip>
        </>
      ) : (
        <>{tags.map((item:any)=>{
          return <div
            style={{
              color: (item?.color?.color && item?.color?.id === 21 ) ? '#fff' : 'inherit'
            }}
          >{item?.name}</div>
        })}</>
      )}
    </Box>
  );
};